import { has } from '@formkit/utils';

// packages/i18n/src/i18n.ts
var i18nNodes = /* @__PURE__ */ new Set();
var globalActiveLocale = null;
function createI18nPlugin(registry) {
  return function i18nPlugin(node) {
    i18nNodes.add(node);
    if (globalActiveLocale)
      node.config.locale = globalActiveLocale;
    if (node.props.__locales__) {
      registry = { ...registry, ...node.props.__locales__ };
    }
    node.on("destroying", () => i18nNodes.delete(node));
    let localeKey = parseLocale(node.config.locale, registry);
    let locale = localeKey ? registry[localeKey] : {};
    node.on("prop:locale", ({ payload: lang }) => {
      localeKey = parseLocale(lang, registry);
      locale = localeKey ? registry[localeKey] : {};
      node.store.touch();
    });
    node.on("prop:label", () => node.store.touch());
    node.on("prop:validationLabel", () => node.store.touch());
    node.hook.text((fragment, next) => {
      const key = fragment.meta?.messageKey || fragment.key;
      if (has(locale, fragment.type) && has(locale[fragment.type], key)) {
        const t = locale[fragment.type][key];
        if (typeof t === "function") {
          fragment.value = Array.isArray(fragment.meta?.i18nArgs) ? t(...fragment.meta.i18nArgs) : t(fragment);
        } else {
          fragment.value = t;
        }
      }
      return next(fragment);
    });
  };
}
function parseLocale(locale, availableLocales) {
  if (has(availableLocales, locale)) {
    return locale;
  }
  const [lang] = locale.split("-");
  if (has(availableLocales, lang)) {
    return lang;
  }
  for (const locale2 in availableLocales) {
    return locale2;
  }
  return false;
}
function changeLocale(locale) {
  globalActiveLocale = locale;
  for (const node of i18nNodes) {
    node.config.locale = locale;
  }
}

export { changeLocale, createI18nPlugin };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=i18n.mjs.map